
export default {
  props: {
    question: { type: String, required: true },
    answer: { type: String, required: true },
  },

  data: () => ({
    isOpen: false,
    timer: null,
  }),

  watch: {
    isOpen (isOpen) {
      const el = this.$refs.answer
      if (!el) return
      el.style.height = `${el.scrollHeight}px`
      if (!isOpen) setTimeout(() => { el.style.height = 0 }, 0)
      this.timer = setTimeout(() => {
        if (isOpen) el.style.height = "auto"
        this.timer = null
      }, 200)
    },
  },

  methods: {
    toggle () {
      if (!this.timer) this.isOpen = !this.isOpen
    },
  },
}
